import {
	type UseQueryOptions,
	keepPreviousData,
	queryOptions,
} from "@tanstack/react-query";
import type {
	ActionInput,
	ActionName,
	ActionOutput,
} from "@/setup/backend/types";

import { actionFetch } from "./actionFetch";
import type { ActionFetchFn } from "./ApiFetchContext";

export function getActionQueryOptions<A extends ActionName>(
	name: A,
	input: ActionInput<A>,
	opts: {
		parseOnly?: boolean;
		batchEnabled?: boolean;
		actionFetchOverride?: ActionFetchFn;
	} = {},
) {
	const fetchFn = opts.actionFetchOverride ?? actionFetch;
	return queryOptions({
		queryKey: [name, opts.parseOnly ?? false, input],
		queryFn: () => fetchFn(name, input, opts.batchEnabled, opts.parseOnly),
		placeholderData: keepPreviousData,
	}) as UseQueryOptions<ActionOutput<A>>;
}
